import { routerMiddleware } from 'react-router-redux';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { routerReducer } from 'react-router-redux';
import mapValues from 'lodash/mapValues';

import history from 'helpers/history';
import rootSaga from 'store/sagas';

import apiStatusReducer from './apiStatus';
import authReducer, { LOGOUT } from './auth';
import bookingsReducer from './bookings';
import customerCreditReducer from './customerCredit';
import faqReducer from './faq';
import paymentMethodsReducer from './paymentMethods';
import referralCouponReducer from './referralCoupon';
import regionReducer from './region';
import navReducer from './nav';
import languageReducer from './language';
import uiReducer from './ui';
import entitiesReducer from './entities';
import contentReducer from './content';

const appReducer = combineReducers({
  apiStatus: apiStatusReducer,
  auth: authReducer,
  bookings: bookingsReducer,
  customerCredit: customerCreditReducer,
  faq: faqReducer,
  paymentMethods: paymentMethodsReducer,
  referralCoupon: referralCouponReducer,
  region: regionReducer,
  language: languageReducer,
  nav: navReducer,
  ui: uiReducer,
  entities: entitiesReducer,
  content: contentReducer,
  router: routerReducer
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    state = mapValues(
      state,
      (value, key) => (key === 'language' ? value : undefined)
    );
  }

  return appReducer(state, action);
};

const sagaMiddleware = createSagaMiddleware();
const middleware = [routerMiddleware(history), sagaMiddleware];

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

store.sagaTask = sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js